
<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('complain.complain_receive') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
            <b-col xs="12" sm="12" md="6">
                <b-form-group
                class="row"
                label-cols-sm="3"
                :label="$t('complain.sender')"
                label-for="org_id"
                >
                <b-form-select
                    plain
                    id="org_id"
                    v-model="search.sender_id"
                    :options="designationList"
                    >
                    <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6">
                <b-form-group
                class="row"
                label-cols-sm="3"
                :label="$t('complain.receiver')"
                label-for="org_id"
                >
                <b-form-select
                    plain
                    id="org_id"
                    v-model="search.receiver_id"
                    :options="designationList"
                    >
                    <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col xs="12" sm="12" md="6">
                <b-form-group
                class="row"
                label-cols-sm="3"
                :label="$t('complain.com_titlel')"
                label-for="com_title"
                >
                <b-form-input
                    id="com_title"
                    v-model="search.com_title"
                    placeholder=""
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6">
                <b-form-group
                class="row"
                label-cols-sm="3"
                :label="$t('complain.notel')"
                label-for="note"
                >
                <b-form-input
                    id="note"
                    v-model="search.note"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('complain.complain_receive') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loading">
              <b-row>
                <b-col md="12"  class="table-responsive">
                  <b-table responsive bordered hover :items="listData" :fields="columns"  aria-hidden="loading | listReload ? 'true' : null">
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(com_title)="data">
                      <span class="capitalize">{{ data.item.com_title.substring(0,20)+".." }}</span>
                    </template>
                    <template v-slot:cell(sender_name)="data">
                      <span class="capitalize">{{ data.item.sender_name }}</span>
                    </template>
                    <template v-slot:cell(sender_designation)="data">
                      <span class="capitalize">{{ data.item.sender_designation }}</span>
                    </template>
                    <template v-slot:cell(status)="data">
                      {{ data.item.status ? $t('globalTrans.inactive') : $t('globalTrans.active') }}
                    </template>
                    <template v-slot:cell(action)="data">
                      <b-button class="mr-1" title="View Complain" v-b-modal.modal-5 variant=" iq-bg-success border" size="sm" @click="details(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                      <!-- <b-button v-b-modal.modal-4 variant=" iq-bg-success mr-1 mb-1" size="sm" @click="edit(data.item)"><i class="ri-ball-pen-fill m-0"></i></b-button> -->
                      <b-button class="mr-1" title="Approve" v-b-modal.modal-1 variant=" iq-bg-success border" size="sm" @click="solveComplain(data.item)"><i class="ri-check-line"></i></b-button>
                      <b-button v-if="data.item.complain_status !== 4" title="Send Compalin" v-b-modal.modal-send variant=" iq-bg-info border" size="sm" @click="sendComplain(data.item)"><i class="ri-send-plane-fill"></i></b-button>
                      <!-- <b-button variant=" iq-bg-danger" size="sm" @click="remove(data.item)"><i class="ri-delete-bin-line m-0"></i></b-button> -->
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-5" size="xl" :title="$t('complain.complian_cycle_details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :id="editItemId" :item="item" :complain_id="complain_id"/>
    </b-modal>
    <b-modal id="modal-send" size="lg" :title="$t('complain.send_complain')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <SendModal :complainId="editItemId" :key="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import DetailModal from './DetailModal'
import SendModal from '../complain-request/SendModal'
import RestApi, { authServiceBaseUrl, commonServiceBaseUrl } from '../../../../../config/api_config'
import { complainSendList, complainInfoSolveStatus, complainSendToggleStatus } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    DetailModal, SendModal
  },
  data () {
    return {
      search: {
        note: '',
        com_title: '',
        sender_id: 0,
        receiver_id: 0
      },
      complain_id: 0,
      item: '',
      rows: [],
      designationList: [],
      complain_detail: '',
      commonServiceBaseUrlImg: commonServiceBaseUrl
    }
  },
  computed: {
    formTitle () {
       return (this.editItemId === 0) ? this.$t('org_pro.org_profile') + ' ' + this.$t('globalTrans.entry') : this.$t('org_pro.org_profile') + ' ' + this.$t('globalTrans.modify')
    },
    orgList () {
      return this.$store.state.commonObj.organizationProfileList
    },
    serviceList () {
      const services = this.$store.state.commonObjCommonConfig.serviceList.filter(item => item.status === 0)
      const listData = services.map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
      return listData
    },
    divisionList () {
      return this.$store.state.commonObj.divisionList
    },
    districtList () {
      return this.$store.state.commonObj.districtList
    },
    upazilaList () {
      return this.$store.state.commonObj.upazilaList
    },
    unionList () {
      return this.$store.state.commonObj.unionList
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('complain.sender_name'), class: 'text-left' },
          { label: this.$t('complain.sender_designation'), class: 'text-left' },
          { label: this.$t('complain.com_titlel'), class: 'text-left' },
          { label: this.$t('complain.notel'), class: 'text-left' },
          { label: this.$t('complain.service'), class: 'text-left' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'sender_name_bn' },
          { key: 'sender_designation_bn' },
          { key: 'com_title_bn' },
          { key: 'note_bn' },
          { key: 'service_name_bn' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'sender_name' },
          { key: 'sender_designation' },
          { key: 'com_title' },
          { key: 'note' },
          { key: 'service_name' },
          { key: 'action' }
        ]
      }
      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
  },
  async created () {
    this.loadData()
    this.getDsignation()
  },
  mounted () {
  },
  methods: {
    async searchData () {
      this.loadData()
    },
    remove (item) {
      this.changeStatus(commonServiceBaseUrl, complainSendToggleStatus, item)
    },
    solveComplain (item) {
      this.$swal({
        title: this.$t('globalTrans.statusChangeMsg'),
        showCancelButton: true,
        confirmButtonText: this.$t('globalTrans.yes'),
        cancelButtonText: this.$t('globalTrans.no'),
        focusConfirm: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.complainSolve(item)
        }
      })
    },
    complainSolve (item) {
      RestApi.deleteData(commonServiceBaseUrl, `${complainInfoSolveStatus}/${item.complain_id}`).then(response => {
        if (response.success) {
          this.$store.dispatch('Complain/updateComplainSendStatus', item)
          this.$toast.success({
            title: this.$t('globalTrans.success'),
            message: this.$t('globalTrans.update_msg'),
            color: '#D6E09B'
          })
        } else {
          this.$toast.error({
            title: 'Error',
            message: 'Operation failed! Please, try again.'
          })
        }
      })
    },
    details (item) {
      this.editItemId = item.id
      this.complain_id = item.complain_id
      this.item = item
    },
    sendComplain (item) {
      this.editItemId = item.complain_id
    },
    addCommittee (item) {
      this.editItemId = item.id
    },
    async loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(commonServiceBaseUrl, complainSendList, params).then(response => {
        if (response.success) {
          this.getRelationalData(response.data)
        }
      })
      this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
    },
    getRelationalData (data) {
      const user = this.$store.state.Auth.authUser
      const designationList = this.$store.state.commonObj.designationList.filter(item => item.status === 0)
      // const statusList = this.$store.state.commonObj.comStatusList
      const listData = data.data.filter(item => item.receiver_id === user.user_id)
      return RestApi.getData(authServiceBaseUrl, 'user/getAllUser').then(response => {
        let tmpData1 = {}
        let tmpData2 = {}
        const complainCycleByReceiverList = listData.map(item => {
          const senderObject = response.data.find(user => user.user_id === item.sender_id)
          const receiverObject = response.data.find(user => user.user_id === item.receiver_id)
          const senderData = {
            sender_name: senderObject.name,
            sender_name_bn: senderObject.name_bn,
            sender_designation_id: senderObject.designation_id
          }
          const receiverData = {
            receiver_name: receiverObject.name,
            receiver_name_bn: receiverObject.name_bn,
            receiver_designation_id: receiverObject.designation_id
          }
          tmpData2 = designationList.find(designation => designation.value === senderData.sender_designation_id)
          tmpData1 = designationList.find(designation => designation.value === receiverData.receiver_designation_id)
          const designationData = {
            sender_designation: tmpData2.text_en,
            sender_designation_bn: tmpData2.text_bn,
            receiver_designation: tmpData1.text,
            receiver_designation_bn: tmpData1.text_bn
          }
          const statusObj = this.$store.state.commonObj.comStatusList.find(statusItem => statusItem.id === item.complain_status)
          const statusData = {
            status_name: statusObj.name,
            status_name_bn: statusObj.name_bn
          }
          return Object.assign({}, item, senderData, receiverData, designationData, statusData)
        })
        this.$store.dispatch('setList', complainCycleByReceiverList)
        this.paginationData(data)
      })
    },
    getDsignation () {
      const designationObject = this.$store.state.commonObj.designationList.filter(item => item.status === 0)
      this.designationList = designationObject.map((obj, index) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    }
  }
}
</script>
